<section class="signin-page">
  <!-- Left Panel - Branding -->
  <div class="signin-branding">
    <div class="branding-content">
      <div class="brand-logo">
        <i class="bi bi-bar-chart-line-fill"></i>
      </div>
      <h1>Social Auditor</h1>
      <p>Analyze social media profiles with powerful insights on audience quality, engagement, and authenticity.</p>

      <div class="features-list">
        <div class="feature-item">
          <i class="bi bi-check-circle-fill"></i>
          <span>Audience quality analysis</span>
        </div>
        <div class="feature-item">
          <i class="bi bi-check-circle-fill"></i>
          <span>Engagement metrics</span>
        </div>
        <div class="feature-item">
          <i class="bi bi-check-circle-fill"></i>
          <span>Demographic insights</span>
        </div>
        <div class="feature-item">
          <i class="bi bi-check-circle-fill"></i>
          <span>Exportable reports</span>
        </div>
      </div>
    </div>

    <div class="branding-decoration">
      <div class="decoration-circle circle-1"></div>
      <div class="decoration-circle circle-2"></div>
      <div class="decoration-circle circle-3"></div>
    </div>
  </div>

  <!-- Right Panel - Login Form -->
  <div class="signin-form-panel">
    <div class="form-container">
      <!-- Header -->
      <div class="form-header">
        <h2>Welcome back</h2>
        <p>Sign in to continue to your dashboard</p>
      </div>

      <!-- Social Login Buttons -->
      <div class="social-login">
        <app-signup-google></app-signup-google>
<!--        <app-signup-fb></app-signup-fb>-->
      </div>

      <!-- Divider -->
      <div class="divider">
        <span>or continue with email</span>
      </div>

      <!-- Login Form -->
      <form class="login-form" (ngSubmit)="onSignin(f)" #f="ngForm">
        <div class="form-group">
          <label for="email">Email address</label>
          <div class="input-wrapper">
            <i class="bi bi-envelope"></i>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email"
              ngModel
              required
              email
              #emailInput="ngModel"
              [class.invalid]="emailInput.invalid && emailInput.touched"
            >
          </div>
          <span class="error-message" *ngIf="emailInput.invalid && emailInput.touched">
            Please enter a valid email address
          </span>
        </div>

        <div class="form-group">
          <div class="label-row">
            <label for="password">Password</label>
            <a [href]="forgotPasswordUrl" class="forgot-link">Forgot password?</a>
          </div>
          <div class="input-wrapper">
            <i class="bi bi-lock"></i>
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              name="password"
              placeholder="Enter your password"
              ngModel
              required
              minlength="6"
              #passwordInput="ngModel"
              [class.invalid]="passwordInput.invalid && passwordInput.touched"
            >
            <button type="button" class="toggle-password" (click)="showPassword = !showPassword">
              <i [class]="showPassword ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
            </button>
          </div>
          <span class="error-message" *ngIf="passwordInput.invalid && passwordInput.touched">
            Password must be at least 6 characters
          </span>
        </div>

        <button
          type="submit"
          class="btn-signin"
          [disabled]="!f.valid"
          [class.loading]="isLoading"
        >
          <span>Sign in</span>
<!--          <span *ngIf="!isLoading">Sign in</span>-->
<!--          <span *ngIf="isLoading" class="spinner"></span>-->
        </button>
      </form>

      <!-- Register Link -->
      <p class="register-link">
        Don't have an account? <a routerLink="/signup">Create one for free</a>
      </p>
    </div>
  </div>
</section>
